import { TrackingCode } from '@sky-distribution/adapter-core-pc-rest-interfaces';
import isEmpty from 'lodash.isempty';
import unionBy from 'lodash.unionby';
import { Submission } from '../service/Policy.service.type';

const DISCOUNT_CODE_TRACKING_CODE_NAME = 'DISCOUNT_CODE';

const EMPLOYEE_ID_UTM_NAME = 'utm_employee_id';
const SALES_CHANNEL_UTM_NAME = 'utm_medium';
const AFFILIATE_LINK_VERSION_UTM_NAME = 'utm_aff_link_version';

export const UTM_NAME_TO_PRODUCER_DATA_KEY_MAP = {
  [EMPLOYEE_ID_UTM_NAME]: 'employeeId',
  [SALES_CHANNEL_UTM_NAME]: 'salesChannel',
  [AFFILIATE_LINK_VERSION_UTM_NAME]: 'utmAffLinkVersion',
};

export type ProducerDataTrackingCodes = {
  employeeId?: string;
  salesChannel?: string;
  utmAffLinkVersion?: string;
};

export const getProducerDataTrackingCodes = (
  trackingCodes?: TrackingCode[],
) => trackingCodes?.reduce((producerData, { name, value }): ProducerDataTrackingCodes => {
  const producerDataKey = Object.entries(UTM_NAME_TO_PRODUCER_DATA_KEY_MAP)
    .find(([utmName]) => utmName === name)?.[1];

  return producerDataKey
    ? {
      ...producerData,
      [producerDataKey]: value,
    }
    : producerData;
}, {} as ProducerDataTrackingCodes);

export const getTrackingCodesFromUtms = (
  utms: Record<string, string>,
): TrackingCode[] | undefined => {
  if (!Object.keys(utms).length) {
    return undefined;
  }

  return Object.entries(utms)
    .map(([name, value]) => ({
      name,
      value,
    }));
};

export const getSubmissionWithTrackingCodes = (
  submission: Submission,
  trackingCodes?: TrackingCode[],
) => {
  const mergedTrackingCodes = unionBy(
    trackingCodes ?? [],
    submission.baseData.trackingCodes ?? [],
    'name',
  );

  return {
    ...submission,
    baseData: {
      ...submission.baseData,
      ...(!isEmpty(mergedTrackingCodes) && { trackingCodes: mergedTrackingCodes }),
    },
  };
};

export const getTrackingCodesFromSubmission = (submission: Submission) => submission?.baseData?.trackingCodes ?? [];

export const getDiscountCodeFromTrackingCodes = (
  trackingCodes: TrackingCode[],
) => trackingCodes.find(({ name }) => name === DISCOUNT_CODE_TRACKING_CODE_NAME)?.value;
